import * as errors from "../errors.js";
import { state } from "../state.js";
/*
    The function VAL finds a numerical value in a string. Space chars and the first minus- (-) and plus-char (+) are ignored. 
    The first minus char is interpreted as negative prefix. The searching of the numerical value stopped, when the first non-numerical 
    char is reached. The first dot (.) is interpreted as decimal point and the first e or E as exponent. Mathematical terms and arithmetic operation are ignored.
    When the argument isn't a string, appears the BASIC error ?TYPE MISMATCH ERROR IN line. It can be only processed numbers with values from 
    -1e+38 until 1e+38. Then this area is out of range the BASIC error ?OVERFLOW ERROR IN line is viewing. When the argument is absent, 
    it appears a ?SYNTAX ERROR IN line. 

    EXAMPLES:
    PRINT VAL("A1") Screen: 0
    PRINT VAL("- 1 2 3 . 2 3 4 e + 23) Screen: -1.23234e+25
    PRINT VAL("1051 E-3 -1.051 C) Screen: 1.051
*/
export const val = async (args) => {
    // If no args are given, throw a syntax error.
    if (!args || args.length === 0) {
        throw new errors.SyntaxError();
    }

    // Check if the args is a string.
    if (typeof args !== "string") {
        throw new errors.TypeMismatchError();
    }

    // Check if the string is not too long.
    if (args.length > state.maxStringLength) {
        throw new errors.StringTooLongError();
    }

    // Remove spaces and extract the first valid numerical value.
    const cleanedInput = args.replace(/\s+/g, ""); // Remove all spaces.
    const match = cleanedInput.match(/^[-+]?\d*\.?\d*(e[-+]?\d+)?/i); // Match a valid number.

    if (!match || match[0] === "") {
        // If no valid number is found, return 0.
        return 0;
    }

    // Parse the matched number.
    const result = parseFloat(match[0]);

    // Check for overflow (if the result is not a finite number or exceeds the range).
    if (!isFinite(result) || Math.abs(result) > state.maxValue) {
        throw new errors.OverflowError();
    }

    // Return the parsed number.
    return result;
};